// extracted by mini-css-extract-plugin
export default {"keypad":"Keypad_keypad__4LyJ7","chosung_wrapper":"Keypad_chosung_wrapper__FB4r-","alphabet_wrapper":"Keypad_alphabet_wrapper__nRgCs","keypad_item":"Keypad_keypad_item__37uzG"};